import { useState } from "react";
import { faqItems } from "@/mocks/gossip";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  const toggle = (i: number) => setOpenIdx((cur) => (cur === i ? null : i));

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      {/* FAQPage structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqItems.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />

      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-primary-600">
            <span className="h-px w-8 bg-primary-400"></span> 常见问题
          </p>
          <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950">
            关于海外吃瓜，你可能想问
          </h2>
        </div>

        <div className="mt-9 grid lg:grid-cols-[1fr_360px] gap-8 items-start">
          <div className="space-y-3">
            {faqItems.map((item, idx) => {
              const open = openIdx === idx;
              return (
                <div
                  key={item.q}
                  className={`rounded-2xl border transition-colors overflow-hidden ${
                    open ? "border-primary-300 bg-background-100" : "border-background-200 bg-background-100/60"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => toggle(idx)}
                    aria-expanded={open}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950">
                      {item.q}
                    </h3>
                    <span
                      className={`flex items-center justify-center w-8 h-8 rounded-full shrink-0 transition-colors ${
                        open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-lg`}></i>
                    </span>
                  </button>
                  {open && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>

          {/* side card */}
          <aside className="rounded-3xl bg-accent-500 text-background-50 p-6 md:p-7 lg:sticky lg:top-24">
            <span className="flex items-center justify-center w-12 h-12 rounded-2xl bg-background-50 text-accent-600">
              <i className="ri-question-answer-line text-2xl"></i>
            </span>
            <h3 className="mt-5 font-heading font-black text-xl">还是没找到答案？</h3>
            <p className="mt-3 text-sm leading-relaxed opacity-90">
              关于收录标准、素材来源、事件状态判定等问题，欢迎直接联系我们，会有专人回复你的疑问。
            </p>
            <a
              href="#contact"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-background-50 px-5 py-2.5 text-sm font-medium text-accent-900 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-mail-send-line"></i> 联系我们
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}